//
import Model from '@/models/Model'

//
import CustomerAccountModel from '@/models/Sale/SlCustomerAccount'
import SaleDebitNoteModel from '@/models/Sale/SlSaleDebitNote'
import SaleInvoiceModel from '@/models/Sale/SlSaleInvoice'

/**
 * This class describes a sl customer account receivable.
 *
 * @class      SlCustomerAccountReceivable (name)
 */
export default class SlCustomerAccountReceivable extends Model {

    /**
     * { item_description }
     */
    static fetches = {
        'sl_customer_account_id': CustomerAccountModel,
        'sl_sale_debit_note_id': SaleDebitNoteModel,
        'sl_sale_invoice_id': SaleInvoiceModel,
    }
    static includes = [
        'sl_customer_account',
        'sl_customer_account.sl_customer',
        'sl_customer_branch_offices',
        'sl_sale_debit_note',
        'sl_sale_invoice.first_pos_sale.g_seller_user.hr_employee',
        'sl_sale_invoice.first_pos_sale.pos_cash_desk.g_branch_office',
    ]

    /**
     * { property_description }
     * @type       {<type>}
     */
    get balance() {
        return Number(this.amount) - Number(this.paid_amount)
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get document_type() {
        return this.is_invoice ? 'Factura' : 'Nota de debito'
    }

    /**
     * { property_description }
     * @type       {<type>}
     */
    get emission_date() {
        return this.is_invoice ? this.sl_sale_invoice_emission_date : this.sl_sale_debit_note_emission_date
    }
    
    /**
     * 
     */
    get first_pos_sale_user_name_case() {
        return this.getProperty('sl_sale_invoice.first_pos_sale.g_seller_user.hr_employee.name_case', '-')
    }
    get is_debit_note() {
        return !! this.sl_sale_debit_note_id
    }
    get is_invoice() {
        return !! this.sl_sale_invoice_id
    }
    get is_paid() {
        return this.amount == this.paid_amount
    }
    get sl_customer_alias_name() {
        return this.sl_customer_account.sl_customer.alias_name
    }
    get sl_customer_branch_offices_address() {
        return this.getProperty('sl_customer_branch_offices.address', '-')
    }

    /**
     * 
     */
    get sl_sale_debit_note_emission_date() {
        return this.getProperty('sl_sale_debit_note.emission_date', '')
    }

    /**
     * 
     */
    get sl_sale_document_branch_office() {
        return this.getProperty('sl_sale_invoice.first_pos_sale.pos_cash_desk.g_branch_office.name')
    }

    get sl_sale_invoice_number() {
        return this.sl_sale_invoice ? this.sl_sale_invoice.number : '-'
    }
    get sl_sale_invoice_status() {
        return this.sl_sale_invoice ? this.sl_sale_invoice.status : '-'
    }

    /**
     * 
     */
    get sl_sale_invoice_emission_date() {
        return this.getProperty('sl_sale_invoice.emission_date', '')
    }

    /**
     *
     */
    resource() {
        return 'sl_customer_account_receivable'
    }
}
